import React, { useEffect } from 'react';
import clsx from 'clsx';
import Portal from '../Portal';
import { useSwipeable } from 'react-swipeable';
import styles from './SlidingPanel.module.scss';

type SlidingPanelProps = {
  children: React.ReactNode;
  className?: string;
  isOpen?: boolean;
  zIndex?: number;
  onClose?: () => void;
  onClick?: (e?: any) => void;
};

export default function SlidingPanel({
  children,
  isOpen = false,
  className = '',
  zIndex = 900,
  onClose = () => {},
  onClick = () => {},
}: SlidingPanelProps) {
  const swipeHandlers = useSwipeable({
    onSwipedDown: (e) => {
      e.event.stopPropagation();
      onClose();
    },
    delta: 50,
    trackMouse: false,
  });

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <Portal>
      <div className={clsx(styles.slidingPanel, isOpen && styles.open)} style={{ zIndex }}>
        <div className={styles.overlay} onClick={onClose} />
        <div className={clsx(styles.content, className)} onClick={onClick} {...swipeHandlers}>
          <div className={styles.dragHandle} />
          {children}
        </div>
      </div>
    </Portal>
  );
}
